export default __webpack_public_path__ + "static/rocket_bw_small-e8448355e4d08640fe792e232d1f9034.mp4";